<template>

    <div class="behavior-report-step-3">

        <p>
            Select a time period for the report card:
        </p>

        <b-card no-body
                v-for="opt in periodOptions">
            <b-card-header>
                <b-form-radio v-model="docData.periodOption"
                              :value="opt.name">
                    {{ opt.title }}
                </b-form-radio>
            </b-card-header>
            <b-card-body v-if="docData.periodOption == opt.name && (opt.name == 'timeOfDay' || opt.name == 'location')">

                <div class="well">
                    <div v-for="period in docData.reportingPeriods">
                        <b-form-input
                            :placeholder="{timeOfDay: 'Enter Time Period', location: 'Enter Location'}[opt.name]"
                            v-model="period.text">
                        </b-form-input>
                        <b-btn variant="default" size="sm"
                               @click="deletePeriod(period)">
                            <open-icon name="delete"></open-icon>
                        </b-btn>
                    </div>

                    <b-btn variant="success" size="sm" class="float-right"
                           @click="addPeriod()"
                           :disabled="addPeriodDisabled">
                        <open-icon name="plus"></open-icon>
                        {{ {timeOfDay: 'Add a time period', location: 'Add a location'}[opt.name] }}
                    </b-btn>
                    <div style="clear:both"></div>
                </div>

            </b-card-body>
        </b-card>

    </div>

</template>

<script>

import Vue from 'vue'
import ToolMixin from '@/providers/ToolMixin'

export default Vue.extend({
    name: "BehaviorReportStep3",
    mixins: [ToolMixin],
    data() {
        return {
            periodOptions: [
                {name: 'daily', title: 'Daily', custom: false},
                {name: 'timeOfDay', title: 'Daily by Time of Day', custom: true},
                {name: 'location', title: 'Daily by Location', custom: true},
                {name: 'weekly', title: 'Weekly', custom: false},
            ]
        }
    },
    methods: {
        addPeriod(period) {
            if (!this.addPeriodDisabled) {
                // use Vue.set() in order to make this fire!
                let reportingPeriods = this.docData.reportingPeriods
                reportingPeriods.push({text: ''})
                Vue.set(this.docData, 'reportingPeriods', reportingPeriods)
            }
        },
        deletePeriod(period) {
            // use Vue.set() in order to make this fire!
            let reportingPeriods = this.docData.reportingPeriods
            reportingPeriods = _.without(reportingPeriods, period)
            Vue.set(this.docData, 'reportingPeriods', reportingPeriods)
        }
    },
    computed: {
        addPeriodDisabled() {
            return this.docData.reportingPeriods &&
                this.docData.reportingPeriods.length >= 5
        }
    },
    watch: {
        // reset reporting periods based on radio selection
        'docData.periodOption'(newVal, oldVal) {
            // use Vue.set() in order to make this fire!
            if (newVal == 'weekly') {
                Vue.set(this.docData, 'reportingPeriods', [
                    {text: 'Mon'},
                    {text: 'Tue'},
                    {text: 'Wed'},
                    {text: 'Thu'},
                    {text: 'Fri'},
                ])
            } else {
                Vue.set(this.docData, 'reportingPeriods', [{text: ''}])
            }
        }
    }
})

</script>
